var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmileyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.3233,
    height: 24.3233,
    rx: 12.1617,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2267 18.6117H14.0967C17.3217 18.6117 18.6117 17.3217 18.6117 14.0967V10.2267C18.6117 7.00167 17.3217 5.71167 14.0967 5.71167H10.2267C7.00167 5.71167 5.71167 7.00167 5.71167 10.2267V14.0967C5.71167 17.3217 7.00167 18.6117 10.2267 18.6117Z",
    stroke: "#5B98D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93665 9.74292C9.58165 10.3879 10.633 10.3879 11.2844 9.74292",
    stroke: "#5B98D2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0388 9.74292C13.6838 10.3879 14.7352 10.3879 15.3866 9.74292",
    stroke: "#5B98D2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83966 12.8067H14.4837C14.8062 12.8067 15.0642 13.0647 15.0642 13.3872C15.0642 14.9933 13.7677 16.2897 12.1617 16.2897C10.5556 16.2897 9.25916 14.9933 9.25916 13.3872C9.25916 13.0647 9.51716 12.8067 9.83966 12.8067Z",
    stroke: "#5B98D2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyIcon);
export default __webpack_public_path__ + "static/media/smiley-icon.f97751a4.svg";
export { ForwardRef as ReactComponent };